import type * as React from 'react';

import { cn } from '@/lib/utils';

interface EmptyStateProps extends React.ComponentProps<'div'> {
    icon?: React.ReactNode;
    title: string;
    description?: string;
    action?: React.ReactNode;
}

/**
 * Empty state — required for every screen's "vide / Day-1" state.
 * Pattern: icon + title + 1-2 lines + CTA.
 * Never render a bare empty table or "Aucune donnée".
 */
function EmptyState({ icon, title, description, action, className, ...props }: EmptyStateProps) {
    return (
        <div
            data-slot="empty-state"
            className={cn(
                'flex flex-col items-center justify-center gap-3 py-12 px-4 text-center',
                className
            )}
            {...props}
        >
            {icon && (
                <div className="flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground [&_svg]:size-6">
                    {icon}
                </div>
            )}
            <div className="flex flex-col gap-1">
                <p className="text-sm font-medium text-foreground">{title}</p>
                {description && (
                    <p className="text-sm text-muted-foreground max-w-sm">{description}</p>
                )}
            </div>
            {action && <div className="mt-1">{action}</div>}
        </div>
    );
}

export type { EmptyStateProps };
export { EmptyState };
